export function useState() {
    return {
        new: null,
        current: null,
        selected: null,
        list: [],
        listActions: [],
        filterIsSet: 1,
        filter: {},
        params: {},
        refresh: [],
        loading: false,
        pagination: null,
    }
}

export function useGetters() {
    return {
        current: state => state.current,
        new: state => state.new,
        selected: state => state.selected,
        list: state => state.list,
        find: state => (id) => findInList(state, id),
        findCurrent: state => findInList(state, state.current),
        get: state => (ids) => getFromList(state, ids),
        getIndex: state =>  (id) => findIndex(state, id),
        filterIsSet: state => state.filterIsSet,
        filter: state => state.filter,
        params: state => state.params,
        loading: state => state.loading,
        refresh: state => state.refresh,
        pagination: state => state.pagination,
        listActions: state => state.listActions,
    }
}

export function useMutators(methods = { update , remove }) {
    const { update, remove } = methods;
    return {
        new(state, object) {
            state.new = object;
        },

        current(state, id) {
            state.current = id;
        },

        filterIsSet(state, status) {
            state.filterIsSet = !!status ? 1 : 0;
        },

        listActions(state, actions) {
            state.listActions = actions;
        },

        filter(state, filter) {
            Object.assign(state.filter, filter);
        },

        setFilter(state, filter) {
            state.filter = filter;
        },

        select(state, id) {
            state.selected = id;
        },

        loading(state, status) {
            state.loading = status;
        },

        list(state, list) {
            state.list = list;
        },

        refresh(state, list ) {
            state.refresh = [...new Set(list)]; // Distinct
        },

        clearRefreshList(state) {
            state.refresh = [];
        },

        clearList(state) {
            state.list = [];
        },

        addToList(state, item) {
            state.list.push(item);
        },

        prependToList(state, item) {
            state.list.unshift(item);
        },

        removeFromList(state, ids) {
            (Array.isArray(ids) ? ids : [ids]).forEach((id) => {
                const index = findIndex(state, id);
                if (index === -1) return;
                remove(state, index);
            });
        },

        updateInList(state, item) {
            const index = findIndex(state, item.id);
            if (index === -1) return;
            update(state, index, item);
        },

        updateOrAddToList(state, item) {
            const index = findIndex(state, item.id);
            if (index !== -1) return update(state, index, item);
            state.list.push(item);
        },

        updateOrPrependToList(state, item) {
            const index = findIndex(state, item.id);
            if (index !== -1) return update(state, index, item);
            state.list.unshift(item);
        },

        pagination(state, pagination) {
            state.pagination = pagination;
        },

        setup(state, data) {
            Object.keys(data).forEach((key) => {
                state[key] = data[key];
            });
        }
    }
}

export function useActions() {
    return {};
}

//====================== Helper methods ===================

export function find(state, id) {
    return findInList(state, id);
}

export function findIndex(state, id) {
    return findIndexInList(state, id);
}

export function update(state, index, data) {
    const item = state.list[index];
    if (typeof item !== 'object') {
        console.warn(index, item);
        return;
    }
    Object.assign(item, data);
}

export function remove(state, index) {
    state.list.splice(index, 1);
    if (typeof state.listMap !== 'undefined') {
        const key = Object.keys(state.listMap).find(k => state.listMap[k] === index);
        if (typeof key === 'undefined') return;
        delete state.listMap[key];
    }
}

export function getFromList(state, ids) {
    if (state.listMap !== 'undefined') {
        return ids.map(id => state.listMap[id.toString()]).map((index) => {
            return state.list[index];
        });
    }
    return state.list.filter((item) => ids.indexOf(item.id) !== -1);
}

export function findInList(state, id) {
    if (typeof id === 'undefined' || id === null) return null;
    if (typeof state.listMap !== 'undefined') {
        const index  = state.listMap[id.toString()];
        return state.list[index];
    }
    return state.list.find(i => i.id && i.id.toString() === id.toString());
}

export function findIndexInList(state, id) {
    if (id === null) return -1;

    if (typeof state.listMap !== 'undefined') {
        const index = state.listMap[id.toString()];
        return typeof index === 'undefined' ? -1 : index;
    }
    return state.list.findIndex(i => i.id.toString() === id.toString());
}

export function loopThroughRelatedStores(list, mutators = [], actions = []) {
    list.forEach((namespace) => {
        mutators.forEach((method) => {
            const mutation = this._mutations[`${namespace}/${method}`];
            if (!mutation) return;
            mutation[0]();
        });
    });
}